import React from 'react';

import classNames from 'classnames';

import { BY_TYPE_BAR_COLOUR, detailMoney, wholePercent } from './contractDashboardHelpers';

/**
 * IB-703 — "Contracted vs actuals — by contract type". One utilisation bar per type; each bar
 * shows actuals as a share of that type's OWN contracted value. The bar fill colour comes from
 * tailwind.config.js and matches the Overview coverage palette.
 */
const UtilisationRow = ({ label, bucket, colour, currencySymbol }) => {
    const contracted = bucket?.contracted_value ?? 0;
    const actual = bucket?.actual_value ?? 0;
    const pct = wholePercent(bucket?.pct);
    const clampedPct = Math.min(Math.max(pct, 0), 100);

    return (
        <div className="tw-flex tw-flex-col tw-gap-2">
            <div className="tw-flex tw-items-baseline tw-justify-between tw-gap-2">
                <span className="tw-text-sm tw-font-semibold tw-text-charcoal">{label}</span>
                <span className="tw-text-xs tw-text-charcoal-50">{$t('{{percent}}% spent', { percent: pct })}</span>
            </div>
            <div className="tw-flex tw-w-full tw-h-3 tw-rounded-md tw-overflow-hidden tw-bg-grey">
                <div className={classNames('tw-h-full', colour)} style={{ width: `${clampedPct}%` }} />
            </div>
            <span className="tw-text-xs tw-text-charcoal-50">
                {$t('{{actual}} actual of {{contracted}} contracted', {
                    actual: detailMoney(currencySymbol, actual),
                    contracted: detailMoney(currencySymbol, contracted),
                })}
            </span>
        </div>
    );
};

const ContractedVsActualsByType = ({ byType, currencySymbol }) => (
    <div className="tw-rounded-lg tw-bg-white tw-shadow-primary tw-px-6 tw-py-6.5">
        <h4 className="tw-text-base tw-font-semibold tw-text-charcoal tw-mb-4">{$t('Contracted vs actuals — by contract type')}</h4>

        <div className="tw-flex tw-flex-col tw-gap-5">
            <UtilisationRow label={$t('Expenditure')} bucket={byType?.expenditure} colour={BY_TYPE_BAR_COLOUR} currencySymbol={currencySymbol} />
            <UtilisationRow label={$t('Workforce')} bucket={byType?.workforce} colour={BY_TYPE_BAR_COLOUR} currencySymbol={currencySymbol} />
            <UtilisationRow label={$t('Revenue')} bucket={byType?.revenue} colour={BY_TYPE_BAR_COLOUR} currencySymbol={currencySymbol} />
        </div>

        <p className="tw-mt-4 tw-text-sm tw-text-charcoal-50">{$t("Each bar shows actuals as a share of that type's own contracted value.")}</p>
    </div>
);

export default ContractedVsActualsByType;
